import MoneyData from '@/atoms/MoneyData';
import Spinner from '@/atoms/loader/Spinner';
import Metrics from '@/molecules/Metrics';
import CustomMarkdown from '@/molecules/CustomMarkdown';
import WalletPlanOptions, { WalletPlanProps } from '@/organisms/WalletPlanOptions';
import ModalClassicLayout from 'context/Modal/layout/Classic';
import { useMyWallet } from 'hooks/queries/marketplace/wallet';
import { useTranslation } from 'react-i18next';

type Props = {
  walletPlanProps: WalletPlanProps;
  closeModal: () => void;
};

const ReloadWallet = ({ closeModal, walletPlanProps }: Props) => {
  const { t } = useTranslation();
  const {
    queryResult: { data, isLoading },
  } = useMyWallet();

  return (
    <ModalClassicLayout closeModal={closeModal} title="reloadwallet.modal.title">
      <div className="flex flex-col gap-2">
        <CustomMarkdown>{t('reloadwallet.modal.description')}</CustomMarkdown>
        <Metrics className="my-4" icon="" subLine="wallet.totalAmount">
          {isLoading && <Spinner />}
          {data && <MoneyData amount={data.balance} currency={data.currency} />}
        </Metrics>
        <WalletPlanOptions {...walletPlanProps} />
      </div>
    </ModalClassicLayout>
  );
};

export default ReloadWallet;
